<template>
  <div class="h-screen bg-background flex flex-col">
    <Header class="shrink-0" />
    <main class="cart-container min-h-0 min-w-0 flex-1 overflow-auto h-full">
      <slot />
    </main>
  </div>
</template>

<script setup lang="ts">
useHead({
  htmlAttrs: {
    class: 'cart-layout'
  },
  bodyAttrs: {
    class: 'cart-layout'
  }
})
</script>
